import React, { PureComponent } from "react";
import { connect } from "react-redux";

import CustomerGroupForm from "./CustomerGroupForm";
import { createCustomerGroup } from "../../actions/customer-groups.actions";

export class CreateCustomerGroup extends PureComponent {
  saveCustomerGroupChanges = customerGroup => {
    this.props.dispatch(createCustomerGroup({ customerGroup }));
  };

  render() {
    return <CustomerGroupForm page={"Create"} saveCustomerGroupChanges={this.saveCustomerGroupChanges} />;
  }
}

export default connect()(CreateCustomerGroup);
